<div
  class="select-wrapper"
  [class.floating]="floating()"
  [class.regular]="!floating()"
  [class.has-value]="hasValue()"
  [class.has-focus]="isFocused()"
  [class]="containerCssClass()"
  [class.has-prefix-icon]="!!prefixIcon()"
  [class.icon-only]="iconOnly()">
  @if (!floating() && label()) {
    <label class="form-label">
      {{ label() }}
      @if (_required()) {
        *
      }
    </label>
  }
  <div class="select-container" [class.has-prefix-icon]="!!prefixIcon()" [class.icon-only]="iconOnly()">
    @if (prefixIcon()) {
      <div class="select-prefix-icon">
        <custom-icon [name]="prefixIcon()!" [size]="prefixIconSize()" [viewBox]="prefixIconViewBox()" />
      </div>
    }

    @if (typeahead()) {
      <ng-select
        [items]="displayOptions()"
        [bindLabel]="bindLabel()"
        [bindValue]="bindValue()"
        [placeholder]="showPlaceholder() ? placeholderText() : ''"
        [clearable]="clearable() && showClearButton()"
        [searchable]="searchable()"
        [loading]="loading()"
        [typeahead]="typeaheadInput"
        [multiple]="multiple()"
        [closeOnSelect]="closeOnSelect()"
        [hideSelected]="hideSelected()"
        [maxSelectedItems]="maxSelectedItems()"
        [appendTo]="appendTo()"
        [notFoundText]="notFoundText()"
        [class]="selectClasses()"
        [class.is-invalid]="hasError()"
        [disabled]="_disabled()"
        [compareWith]="compareWith.bind(this)"
        [(ngModel)]="_value"
        (change)="onItemSelected($event)"
        (clear)="onClear()"
        (open)="onOpen()"
        (close)="closed.emit()"
        (search)="search.emit($event.term); typeaheadInput.next($event.term)"
        (add)="add.emit($event)"
        (remove)="remove.emit($event)"
        (scroll)="scrollToEnd.emit()"
        (focus)="focus.emit()"
        (blur)="blur.emit()">
        <ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$">
          <div class="d-flex align-items-center gap-2 text-truncate" [title]="item.tooltip || ''">
            @if (checkboxes()) {
              <input type="checkbox" [checked]="item$.selected" style="pointer-events: none" class="form-check-input mt-0" />
            }
            @if (item.icon) {
              <custom-icon [name]="item.icon" [size]="16" />
            }
            <span class="text-truncate">{{ item[bindLabel()] }}</span>
          </div>
        </ng-template>

        @if (customLabel()) {
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="d-flex align-items-center">
              {{ customLabel() }}
            </div>
          </ng-template>
        }

        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex align-items-center gap-2 text-truncate" [title]="item.tooltip || ''">
            @if (item.icon) {
              <custom-icon [name]="item.icon" [size]="16" />
            }
            <span class="text-truncate">{{ item[bindLabel()] }}</span>
          </div>
        </ng-template>
      </ng-select>
    } @else {
      <ng-select
        [items]="displayOptions()"
        [bindLabel]="bindLabel()"
        [bindValue]="bindValue()"
        [placeholder]="showPlaceholder() ? placeholderText() : ''"
        [clearable]="clearable() && showClearButton()"
        [searchable]="searchable()"
        [loading]="loading()"
        [multiple]="multiple()"
        [closeOnSelect]="closeOnSelect()"
        [hideSelected]="hideSelected()"
        [maxSelectedItems]="maxSelectedItems()"
        [appendTo]="appendTo()"
        [notFoundText]="notFoundText()"
        [class]="selectClasses()"
        [class.is-invalid]="hasError()"
        [disabled]="_disabled()"
        [compareWith]="compareWith.bind(this)"
        [(ngModel)]="_value"
        (change)="onItemSelected($event)"
        (clear)="onClear()"
        (open)="onOpen()"
        (close)="closed.emit()"
        (search)="search.emit($event.term)"
        (add)="add.emit($event)"
        (remove)="remove.emit($event)"
        (scroll)="scrollToEnd.emit()"
        (focus)="focus.emit()"
        (blur)="blur.emit()">
        <ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$">
          <div class="d-flex align-items-center gap-2 text-truncate" [title]="item.tooltip || ''">
            @if (checkboxes()) {
              <input type="checkbox" [checked]="item$.selected" style="pointer-events: none" class="form-check-input mt-0" />
            }
            @if (item.icon) {
              <custom-icon [name]="item.icon" [size]="16" />
            }
            <span class="text-truncate">{{ item[bindLabel()] }}</span>
          </div>
        </ng-template>

        @if (customLabel()) {
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="d-flex align-items-center">
              {{ customLabel() }}
            </div>
          </ng-template>
        }

        <ng-template ng-label-tmp let-item="item">
          <div class="d-flex align-items-center gap-2 text-truncate" [title]="item.tooltip || ''">
            @if (item.icon) {
              <custom-icon [name]="item.icon" [size]="20" viewBox="0 0 24 24" />
            }
            <span class="text-truncate">{{ item[bindLabel()] }}</span>
          </div>
        </ng-template>
      </ng-select>
    }

    @if (floating() && label()) {
      <label class="floating-label">
        {{ label() }}
        @if (_required()) {
          *
        }
      </label>
    }
  </div>
</div>

@if (errorMessage()) {
  <div class="invalid-feedback d-block">{{ errorMessage() }}</div>
}
